<template>
  <Teleport to="body">
    <transition name="license-access-warning">
      <div v-if="modelValue" class="license-access-warning-overlay" @click.self="close">
        <div class="license-access-warning-modal" dir="rtl" role="dialog" aria-modal="true"
          aria-labelledby="license-access-warning-title" @click.stop>
          <ModalHeader>
            <template #default>
              <h2 id="license-access-warning-title">اطلاعیه تمدید پیشخوان</h2>
            </template>
            <template #actions>
              <BaseButton class="license-access-warning-close" title="×" variant="ghost" type="button"
                aria-label="بستن" @click="close" />
            </template>
          </ModalHeader>

          <div class="license-access-warning-body">
            <div class="license-access-warning-icon" aria-hidden="true">!</div>
            <p v-if="daysLeft < 0">مدت اعتبار سامانه شما به پایان رسیده است. لطفاً برای تمدید پیشخوان اقدام نمایید.</p>
            <p v-else>مدت اعتبار سامانه شما رو به اتمام است. لطفاً برای تمدید پیشخوان اقدام کنید.</p>
          </div>

          <div class="license-access-warning-actions">
            <BaseButton title="تمدید پیشخوان" variant="primary" type="button" @click="renew" />
            <BaseButton title="بستن" variant="cancel" type="button" @click="close" />
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import ModalHeader from "@/components/Common/ModalHeader.vue";
import BaseButton from "@/components/UiCompunents/BaseButton.vue";

defineProps({
  modelValue: { type: Boolean, default: false },
  daysLeft: { type: Number, default: null },
});

const emit = defineEmits(["update:modelValue", "renew"]);

function close() {
  emit("update:modelValue", false);
}

function renew() {
  emit("update:modelValue", false);
  emit("renew");
}
</script>

<style scoped src="./LicenseAccessWarningModal.style.css"></style>
